import { gql } from "@apollo/client";

/**
 * The whole list, unfiltered.
 *
 * `filter` and `blockedOnly` exist on the server but are deliberately not used:
 * all 251 countries fit in one response, so the screen fetches once on open and
 * filters in the browser. Sending `filter` would turn every keystroke into a
 * request against an admin-metered API for no gain.
 *
 * No `pollInterval`. The list only changes when an admin changes it, and the
 * server caches for 30s per instance anyway — a timer would mostly re-read its
 * own cache.
 *
 * `blockedCount` and `totalCount` ignore the server-side filter args by design,
 * so they stay usable as header counts.
 */
export const COUNTRY_BLOCK_LIST = gql`
  query CountryBlockList {
    countryBlockList {
      countries {
        countryCode
        name
        phoneCode
        blocked
        phoneBlocked
        phoneBlockingNote
        iso3
        numericCode
        continent
        region
        capital
        blockedAt
        blockedBy
        recognized
      }
      blockedCount
      totalCount
      updatedAt
      warnings
    }
  }
`;
